/**
 * Allowlist schemes before handing a URL to a navigation sink
 * (window.open / location.assign / <a href>). Blocks javascript:/data:/etc XSS.
 */
export const isSafeHttpUrl = (raw?: string): boolean => {
	if (!raw) return false;
	try {
		const url = new URL(raw, window.location.origin);
		return url.protocol === "https:" || url.protocol === "http:";
	} catch {
		return false;
	}
};

export const isSafeMailtoUrl = (raw?: string): boolean => {
	if (!raw) return false;
	try {
		const url = new URL(raw);
		return url.protocol === "mailto:";
	} catch {
		return false;
	}
};
